import React, { createContext, useContext, useState, ReactNode } from 'react';
import { StaffMember } from '@/constants/staff';

interface StaffContextType {
  currentStaff: StaffMember | null;
  setCurrentStaff: (staff: StaffMember | null) => void;
  clearCurrentStaff: () => void;
}

const StaffContext = createContext<StaffContextType | undefined>(undefined);

const STORAGE_KEY = 'tpv_current_staff';

export const StaffProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [currentStaff, setCurrentStaffState] = useState<StaffMember | null>(() => {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    return stored ? JSON.parse(stored) : null;
  });

  const setCurrentStaff = (staff: StaffMember | null) => {
    setCurrentStaffState(staff);
    if (staff) {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(staff));
    } else {
      sessionStorage.removeItem(STORAGE_KEY);
    }
  };

  const clearCurrentStaff = () => {
    setCurrentStaffState(null);
    sessionStorage.removeItem(STORAGE_KEY);
  };

  return (
    <StaffContext.Provider value={{ currentStaff, setCurrentStaff, clearCurrentStaff }}>
      {children}
    </StaffContext.Provider>
  );
};

export const useStaff = () => {
  const context = useContext(StaffContext);
  if (context === undefined) {
    throw new Error('useStaff must be used within a StaffProvider');
  }
  return context;
};
